
import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
 import NavbarBottom from './Components/NavbarBottom';
 import Navbars  from './Components/Navbar';
 import Home from './Components/Home';
import SideEvent from './Components/SideEvent';
import Speakers from './Components/Speakers';
import Category from './Components/Category';
import Agenda from './Components/Agenda';
// import Loading from './Components/Loading';

function App() {
  return (
    
    // <Loading/>
     <BrowserRouter>
     
     <Navbars/>
    <Routes>
   
      <Route path="/" element={<NavbarBottom/>}></Route>
      <Route path="/Home" element={<Home/>}></Route>
      <Route path="/SideEvent" element={<SideEvent/>}></Route>
      <Route path="/Speakers" element={<Speakers/>}></Route>
      <Route path="/Category" element={<Category/>}></Route>
      <Route path="/Agenda"  element={<Agenda/>}></Route>
      
    </Routes>
   
 </BrowserRouter>
 );
}

export default App;
